import React, { Component } from "react";
import { connect } from "react-redux";
import style from "../css/listModalPopup.css";
// constants
import { ASSETS_URL } from "../../../constants/endpoints";
import {
  ALERT_NOTIFICATION,
  INFO_NOTIFICATION,
  LIST_NOTIFICATION_MODAL_TYPE,
  REALITY_CHECK_MODAL_TYPE,
  RSD,
  SUCCESS_NOTIFICATION,
  WARNING_NOTIFICATION,
} from "../../../constants/identifiers";
//actions
import { openCloseModal } from "../../../actions/modalActions";
import { openCloseSettings } from "../../../actions/settingsActions";
// helpers
import { getText } from "../../../helpers/localization";
import { openCloseHelpPages } from "../../../actions/helpPagesActions";
import { openCloseAccumulatorBoost } from "../../../actions/accumulatorBoostAction";

const mapStateToProps = (state, ownProps) => {
  return {
    isModalOpen: state.vpp.isModalOpen,
    notificationType: state.vpp.notificationType,
    notificationTitle: state.vpp.notificationTitle,
    notificationText: state.vpp.notificationText,
    isNotificationLocalizable: state.vpp.isNotificationLocalizable,
    notificationWildCards: state.vpp.notificationWildCards,
    isNotificationDismissible: state.vpp.isNotificationDismissible,
    isSettingsOpen: state.vpp.isSettingsOpen,
    isHelpPagesOpen: state.vpp.isHelpPagesOpen,
    isAccumulatorBoostPagesOpen: state.vpp.isAccumulatorBoostPagesOpen,
    isRealityCheckWarningOpen: state.vpp.isRealityCheckWarningOpen,
    isDemoplayNotificationOpen: state.vpp.isDemoplayNotificationOpen,
    systemLanguage: state.vpp.systemLanguage,
  };
};

class ListModalPopup extends Component {
  constructor(props) {
    super(props);

    let store = this.props.store;
    let storeData = store.getState();

    this.state = {
      isModalOpen: storeData.vpp.isModalOpen,
      notificationType: storeData.vpp.notificationType,
      notificationTitle: storeData.vpp.notificationTitle,
      notificationText: storeData.vpp.notificationText,
      isNotificationLocalizable: storeData.vpp.isNotificationLocalizable,
      notificationWildCards: storeData.vpp.notificationWildCards,
      isNotificationDismissible: storeData.vpp.isNotificationDismissible,
      isSettingsOpen: storeData.vpp.isSettingsOpen,
      isHelpPagesOpen: storeData.vpp.isHelpPagesOpen,
      isAccumulatorBoostPagesOpen: storeData.vpp.isAccumulatorBoostPagesOpen,
      isRealityCheckWarningOpen: storeData.vpp.isRealityCheckWarningOpen,
      isDemoplayNotificationOpen: storeData.vpp.isDemoplayNotificationOpen,
      systemLanguage: storeData.vpp.systemLanguage,
    };
  }

  componentWillReceiveProps(nextProps) {
    let store = nextProps.store;
    let storeData = store.getState();

    this.setState({
      isModalOpen: storeData.vpp.isModalOpen,
      notificationType: storeData.vpp.notificationType,
      notificationTitle: storeData.vpp.notificationTitle,
      notificationText: storeData.vpp.notificationText,
      isNotificationLocalizable: storeData.vpp.isNotificationLocalizable,
      notificationWildCards: storeData.vpp.notificationWildCards,
      isNotificationDismissible: storeData.vpp.isNotificationDismissible,
      isSettingsOpen: storeData.vpp.isSettingsOpen,
      isHelpPagesOpen: storeData.vpp.isHelpPagesOpen,
      isAccumulatorBoostPagesOpen: storeData.vpp.isAccumulatorBoostPagesOpen,
      isRealityCheckWarningOpen: storeData.vpp.isRealityCheckWarningOpen,
      isDemoplayNotificationOpen: storeData.vpp.isDemoplayNotificationOpen,
      systemLanguage: storeData.vpp.systemLanguage,
    });
  }

  componentDidMount() {
    document.body.style.overflow = "hidden";
  }

  componentWillUnmount() {
    document.body.style.overflow = "auto";
  }

  _closeModal() {
    if (this.state.isNotificationDismissible) {
      if (this.state.isModalOpen) {
        this.props.store.dispatch(openCloseModal());
      } else if (this.state.isSettingsOpen) {
        this.props.store.dispatch(openCloseSettings());
      } else if (this.state.isHelpPagesOpen) {
        this.props.store.dispatch(openCloseHelpPages());
      } else if (this.state.isAccumulatorBoostPagesOpen) {
        this.props.store.dispatch(openCloseAccumulatorBoost());
      }
    }
  }

  render() {
    let topBarStyle = style.topBar;
    let title = this.props.title;
    let content = this.props.content;
    let containerStyle = "";

    let contentStyle =
      this.props.contentStyle !== undefined
        ? this.props.contentStyle
        : style.content;

    if (this.props.modalType === LIST_NOTIFICATION_MODAL_TYPE) {
      switch (this.state.notificationType) {
        case ALERT_NOTIFICATION:
          topBarStyle = `${topBarStyle} ${style.alert}`;
          contentStyle = `${contentStyle} ${style.alertContent}`;
          break;
        case WARNING_NOTIFICATION:
          topBarStyle = `${topBarStyle} ${style.warning}`;
          break;
        case INFO_NOTIFICATION:
          topBarStyle = `${topBarStyle} ${style.info}`;
          break;
        case SUCCESS_NOTIFICATION:
          topBarStyle = `${topBarStyle} ${style.success}`;
          break;
        default:
          break;
      }
      if (this.state.notificationTitle !== undefined) {
        title = this.state.isNotificationLocalizable
          ? getText(this.state.notificationTitle, this.props.store)
          : this.state.notificationTitle;
      }

      content =[];
      for (let index = 0; index < this.state.notificationText.length; index++) {
        content.push(
          this.state.isNotificationLocalizable
            ? getText(
                this.state.notificationText[index],
                this.props.store,
                this.state.notificationWildCards[index]
              )
            : this.state.notificationText[index]
        );
      }
    }

    let modalPopupCustomStyle =
      this.props.customStyle !== undefined ? this.props.customStyle : "";

    let closeButton = "";
    if (this.state.isNotificationDismissible) {
      closeButton = (
        <div
          className={style.closeButton}
          id="modalCloseBtn"
          onClick={() => this._closeModal()}
        >
          <img
            src={`${ASSETS_URL}close.svg`}
            className={style.closeButton}
            alt={"close"}
          />
        </div>
      );
    }

    return (
      <div className={style.modalWrapper} onClick={() => this._closeModal()}>
        <div
          className={`${style.modal} ${modalPopupCustomStyle} ${containerStyle}`}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <div className={topBarStyle}>
            <div
              className={
                this.props.store.getState().vpp.systemCurrency === RSD
                  ? style.titleforRSD
                  : style.title
              }
              id="modalTitle"
            >
              {title}
            </div>
            {closeButton}
          </div>
          <div className={contentStyle} id="modalContent">
            {content.map((item, index) => (
                    <li className = { style.list} key={index}>{item}</li>
                ))
            }
          </div>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps)(ListModalPopup);



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/containers/listModalPopup.js